module.exports = __webpack_public_path__ + "media/images/flags/16/Argentina-eabe5414068474323d1e7a64ab20f1dc.png";